import React from "react";

import PageTitle from "../../../components/PageTitle";
import { default as QuestionFrame } from "../../../components/QuestionsFrame";
import RadioGroup from "../../../components/RadioGroup";
import Persons from "./Persons";

const ProtectedPersons: React.FC = () => {
  return (
    <>
      <PageTitle heading="Protected persons" />
      <QuestionFrame>
        <RadioGroup
          name="prp_person"
          optionChildren={{
            no: (
              <>
                <p>
                  Please provide the first and last name of the protected people
                  on the original order.
                </p>
                <Persons />
              </>
            ),
          }}
        />
      </QuestionFrame>
      <PageTitle heading="Court Applications for Children" />
      <QuestionFrame>
        <RadioGroup name="prp_ord_fc" />
      </QuestionFrame>
    </>
  );
};

export default ProtectedPersons;
